import React from 'react'
import Button from '@material-ui/core/Button'
import { useAuth } from 'lib/auth'
import {
  getRegistrationDisabled,
  getRegistrationButtonLabel,
} from './registration-cta-utils'
import { useRegistrationInvite } from './registration-invite'

const RegisterButton = ({
  groupEvent,
  paymentRequired,
  type,
  component,
  to,
}) => {
  const { user } = useAuth()
  const { isValid: inviteValid } = useRegistrationInvite()
  const registrationDisabled = getRegistrationDisabled({
    user,
    groupEvent,
    inviteValid,
  })

  const label = getRegistrationButtonLabel({
    user,
    groupEvent,
    paymentRequired,
    inviteValid,
  })

  return (
    <Button
      variant="contained"
      color="primary"
      size="large"
      fullWidth
      disabled={registrationDisabled}
      {...{ type, component, to }}
    >
      {label}
    </Button>
  )
}

export default RegisterButton
